import { createContext, createRef, useContext, useMemo, useState } from 'react';
import { useViewedVehicle } from '../hooks/useViewedVehicle';
import ReactImageGallery from 'react-image-gallery';
import { VehicleSection, VehicleSectionImage } from '../../../../types/vehicle';
import { SectionConfig } from '../../../../services/api/vehicle-sections/types';

type Props = {
  children: React.ReactNode;
  publicView?: boolean;
};

const imageGalleryRef = createRef<ReactImageGallery>();

type ViewVehicleContextType = {
  setActiveSection: (sectionId: string) => void;
  activeSection: string;
  imageGalleryRef: React.RefObject<ReactImageGallery>;
  initialFullScreenIndex: number | null;
  fullScreenImageModalOpen: boolean;
  images: VehicleSectionImage[];
  openFullScreenWithIndex: (i: number) => void;
  openFullScreenWithId: (id: number) => void;
  closeFullScreen: () => void;
  publicView?: boolean;
};

const defaultValue: ViewVehicleContextType = {
  activeSection: '',
  setActiveSection: () => {},
  imageGalleryRef,
  initialFullScreenIndex: null,
  fullScreenImageModalOpen: false,
  openFullScreenWithIndex: () => {},
  openFullScreenWithId: () => {},
  closeFullScreen: () => {},
  images: []
};

export const ViewSectionsList = ['exterior', 'interior', 'mechanical'];

const ViewVehicleContext = createContext(defaultValue);

const filterEmptyCheckboxSections = (sections: Record<string, VehicleSection[]>) => {
  return Object.keys(sections).filter(key => {
    const sectionKey = key as keyof SectionConfig;
    const vehicleSections = sections[sectionKey];
    const isCheckboxSection = sectionKey === 'title_issues' || sectionKey === 'power_equipment';
    const hasSelectedCheckboxes = isCheckboxSection && vehicleSections?.[0]?.checkboxes?.some(c => c.selected);

    return !(isCheckboxSection && !hasSelectedCheckboxes);
  });
};

export const ViewVehicleProvider = ({ children, publicView }: Props) => {
  const vehicle = useViewedVehicle();
  const [activeSection, setActiveSection] = useState('exterior');
  const [fullScreenImageModalOpen, setFullScreenImageModalOpen] = useState(false);
  const [initialFullScreenIndex, setInitialFullScreenIndex] = useState<number | null>(null);

  const images = useMemo(() => {
    return [];
    // if (!vehicle) return [];
    // return ViewSectionOrder.flatMap(sectionOrder => {
    //   const [section, subSections] = sectionOrder;
    //   if (section === 'dealer_comments' || subSections.length === 0) return [];
    //   const vehicleSectionImages = vehicle.vehicleSections.find(s => s.section.name === section);
    //   if (!vehicleSectionImages) return [];
    //   const sectionImages: VehicleSectionImage[] = [];
    //   for (const subSection of subSections) {
    //     const vehicleSection = vehicle.vehicleSections.find(
    //       s => s.section.name === section && s.section.sub_section_name === subSection
    //     );
    //     if (!vehicleSection || vehicleSection.images.length === 0) continue;
    //     sectionImages.push(...vehicleSection.images.filter(i => !!i.url));
    //   }
    //   return sectionImages;
    // });
  }, [vehicle]);

  const openFullScreenWithIndex = (i: number) => {
    setInitialFullScreenIndex(i);
    setFullScreenImageModalOpen(true);
  };

  const openFullScreenWithId = (id: number) => {
    const index = images.findIndex((i: any) => i.id === id);
    if (index === -1) return;
    setInitialFullScreenIndex(index);
    setFullScreenImageModalOpen(true);
  };

  const closeFullScreen = () => {
    setInitialFullScreenIndex(null);
    setFullScreenImageModalOpen(false);
  };

  return (
    <ViewVehicleContext.Provider
      value={{
        activeSection,
        setActiveSection,
        imageGalleryRef,
        initialFullScreenIndex,
        fullScreenImageModalOpen,
        openFullScreenWithId,
        openFullScreenWithIndex,
        images,
        closeFullScreen,
        publicView
      }}
    >
      {children}
    </ViewVehicleContext.Provider>
  );
};

export const useViewVehicleContext = () => {
  const context = useContext(ViewVehicleContext);
  return context;
};
